import { Box, CircularProgress } from '@mui/material';

export const LoadingScreen = () => (
  <Box
    sx={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 1,
      p: 4,
    }}
  >
    <CircularProgress size={80} />
  </Box>
);
